import { render, staticRenderFns } from "./PatientContact.vue?vue&type=template&id=904fd390&scoped=true&"
import script from "./PatientContact.vue?vue&type=script&lang=js&"
export * from "./PatientContact.vue?vue&type=script&lang=js&"
import style0 from "./PatientContact.vue?vue&type=style&index=0&id=904fd390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904fd390",
  null
  
)

export default component.exports